module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATBJREFUeNp00jFLQlEUwPGnPdOwErKWhhr7BEFDS+YSbo0tLg1Rg7MOfQOhMbQth+aGKFqsxb0lcGkQBKEkoinM2//AuXW46YXf4/LuPfedc96NnHORkcQh7pEP1n4lo7+RwgHquIND3lhCLBsTEqljE486v8GC3yT78I1bNGLzpVd0sIMhnkzQGIuoYi3MdxVtNKfUU0TP1iSjjzJ6yEX/Rxvv4UkzE7oppPYMjvHic95HQTvoVMJ8wde0izM54YjJqTbhw2x2pnNSxkjTa0kKXdSQQ1rTyJgUZT6H2L+Tx7O+DOs7QWHajZjH1oROSXrn2A4XpBHXuMKF/tRYA1J6YEt/w4MNqmGAkhbsu/emV2cdGzbI5zmLZawYexiijqytyV7YcFziExV82YUfAQYAh3Eo0TTxdCAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/TRIALICON.png
// module id = 0A2Z
// module chunks = 18